var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-title"},[_c('h1',[(_vm.icon)?_c('i',{class:`fas ${_vm.icon}`}):_vm._e(),_vm._v(" "+_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }